import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/[id]/[date]/[secrect]/sentry/test/')({
  component: RouteComponent,
})

function RouteComponent() {
    return <button onClick={() => {throw new Error("This is your first error!");}}>Break the world</button>;
}
